import { Injectable } from '@angular/core';
import { getCurrentUser, getUserEmail } from '@fantaz/shared/auth';
import {
  GameHistoryService,
  TournamentApiService,
} from '@fantaz/shared/data-access/api';
import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as CasualTournamentActions from './casual-tournament.actions';

@Injectable()
export class CasualTournamentEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CasualTournamentActions.loadCasualTournaments),
        switchMap((options) => {
          return this.tournamentApiService
            .findPromoteTournament(
              {},
              {
                tournamentType: options.tournamentType,
                retiredEvents: options.retiredEvents,
                comingSoonOnly: options.comingSoonOnly,
                active: options.active,
              },
            )
            .pipe(
              map((data: CasualTournamentEntity[]) => {
                return CasualTournamentActions.loadCasualTournamentSuccess({
                  casualTournament: data,
                });
              }),
              catchError((error) => {
                return of(
                  CasualTournamentActions.loadCasualTournamentFailure({
                    error,
                  }),
                );
              }),
            );
        }),
      ),
    { dispatch: true },
  );
  loadSubscriptionTournament$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CasualTournamentActions.loadSubscriptionTournament),
        withLatestFrom(this.store.select(getUserEmail)),
        switchMap(([{ eventPrototypeUuid, eventSchedule }, email]) => {
          if (email) {
            return this.tournamentApiService
              .getSubscriptionStatus({
                eventPrototypeUuid,
                eventScheduleUuid: eventSchedule.uuid,
                email,
              })
              .pipe(
                map((data) => {
                  return CasualTournamentActions.loadSubscriptionTournamentSuccess(
                    {
                      eventPrototypeUuid,
                      eventSchedule,
                      status: data.status,
                    },
                  );
                }),
                catchError((error) => {
                  return of(
                    CasualTournamentActions.loadSubscriptionTournamentFailure({
                      error,
                    }),
                  );
                }),
              );
          } else {
            return [];
          }
        }),
      ),
    { dispatch: true },
  );
  getTimesUserTournamentPlayed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CasualTournamentActions.getTimesUserTournamentPlayed),
        withLatestFrom(this.store.select(getCurrentUser)),
        switchMap(([{ tournamentList }, currentUser]) => {
          if (currentUser) {
            return this.gameHistory
              .getTimesUserPlayedTournaments(tournamentList)
              .pipe(
                map((data) => {
                  return CasualTournamentActions.getTimesUserTournamentPlayedSuccess(
                    { timesPlayedInTournament: data },
                  );
                }),
                catchError((error) => {
                  return of(
                    CasualTournamentActions.getTimesUserTournamentPlayedFailure(
                      {
                        error,
                      },
                    ),
                  );
                }),
              );
          } else {
            return [];
          }
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private readonly actions$: Actions,
    private store: Store,
    private tournamentApiService: TournamentApiService,
    private gameHistory: GameHistoryService,
  ) {}
}
